module.exports = __webpack_public_path__ + "img/6_81.863a1a02.png";